export default "__VITE_ASSET__bs4FYa_4__"